import {
  IBasicDataFeed,
  IDatafeedQuotesApi,
} from "../charting_library/charting_library";
import "./store";
import {
  resolveSymbol,
  getBars,
  onReady,
  searchSymbols,
  subscribeBars,
  unsubscribeBars,
} from "./handlers";
import { getQuotes, subscribeQuotes, unsubscribeQuotes } from "./quotes";
import { connectSocket } from "./socket";

// socket connect ----------------------------------------
connectSocket();

export default <IBasicDataFeed & IDatafeedQuotesApi>{
  onReady,
  searchSymbols,
  resolveSymbol,
  getBars,
  subscribeBars,
  unsubscribeBars,
  getQuotes,
  subscribeQuotes,
  unsubscribeQuotes,
};
